import '../pages/Auth/index.css';

import React from 'react';
import { Helmet } from 'react-helmet';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import AuthRoute from '../components/Auth/AuthRoute';
import AcceptInvitation from '../pages/Auth/AcceptInvitation';
import ForgotPassword from '../pages/Auth/ForgotPassword';
import Login from '../pages/Auth/Login';
import ResetPassword from '../pages/Auth/ResetPasword';

const AuthContainer: React.FC<RouteComponentProps> = ({ match: { path } }) => {
  return (
    <div className="auth__wrapper">
      <Helmet>
        <title>CINCH Health - Authentication</title>
      </Helmet>
      <div className="auth__logo">
        <h1>CINCH Health</h1>
      </div>
      <Switch>
        <AuthRoute exact path={`${path}/login`}>
          <Login />
        </AuthRoute>
        <Route path={`${path}/forgot-password`} component={ForgotPassword} />
        <Route path={`${path}/accept/:code`} component={AcceptInvitation} />
        <Route
          path={`${path}/reset-password/:code`}
          component={ResetPassword}
        />
        <Redirect from="*" to={`${path}/login`} />
      </Switch>
    </div>
  );
};

export default AuthContainer;
